import gsap from 'gsap'
import tailwindConfig from '../../tailwind.config';

export default function(){
	let dots = document.querySelectorAll('.dot');
	
	if ( dots.length > 0 ) {
		const smScreen = tailwindConfig.theme.screens.sm.replace('px', '');
		const mdScreen = tailwindConfig.theme.screens.md.replace('px', '');
		const lgScreen = tailwindConfig.theme.screens.lg.replace('px', '');
		const xlScreen = tailwindConfig.theme.screens.xl.replace('px', '');
		const xl2Screen = tailwindConfig.theme.screens['2xl'].replace('px', '');

		closeAllTooltips()

		let windowScreenWidth = window.screen.width
		let windowScreenHeight = window.screen.height

		// Close all tooltips except current if any.
		function closeAllTooltips ( current = null ){
			dots.forEach(dot => {
				if ( dot.querySelector( '[data-js="tooltip"]' ) ) {
					const tooltip = dot.querySelector( '[data-js="tooltip"]' )
	
					if ( tooltip!== current ) {
						closeTooltip( tooltip )
					}
				}
			});
		}

		function openTooltip ( tooltip ) {
			// Show
			tooltip.classList.remove('h-0', 'overflow-hidden', 'poiter-events-none' )

			// Set position
			if ( window.innerWidth <= 991 ) {
				tooltip.style.top = '80px'
				tooltip.style.bottom = 'auto'
				tooltip.style.right = 'auto'
				tooltip.style.left = '50%'
				tooltip.style.transform = 'translateX(-50%)'
				tooltip.style.position = 'fixed'
			} else {
				if ( tooltip.getBoundingClientRect().left > windowScreenWidth / 2 ) {
					tooltip.style.right = 0
					tooltip.style.left = 'auto'
				} else {
					tooltip.style.left = 0
					tooltip.style.right = 'auto'
				}
	
				if ( tooltip.getBoundingClientRect().top > windowScreenHeight / 2 ) {
					tooltip.style.top = 'auto'
					tooltip.style.bottom = '50px'
				} else {
					tooltip.style.top = '20px'
					tooltip.style.bottom = 'auto'
				}
			}

			// Open
			tooltip.classList.add('is-open' )
			gsap.to( tooltip, { autoAlpha: 1, duration: 0.5 } );
		}

		function closeTooltip( tooltip ){
			tooltip.classList.remove('is-open' )
			gsap.to( tooltip, { autoAlpha: 0, duration: 0.5 } );

			setTimeout(function(){
				tooltip.classList.add('h-0', 'overflow-hidden', 'poiter-events-none' )
			}, 500)
		}
	
		// FIXME: this needs to be update with the new map.
		if ( false && dots.length > 0 ) {
			setTimeout(() => {
				dots.forEach((dot, index) => {
					// Set the dot in position
					let dotNumber = index + 1
					let dotSVG = document.querySelector('svg#college-map circle#dot-' + dotNumber )
	
					let dotX = dotSVG.getBoundingClientRect().x
					let dotY = dotSVG.getBoundingClientRect().y

					console.log(dotX);
					console.log(dotSVG.getClientRects()[0].x);
					console.log('-----------------------');
	
					dot.style.left = dotX + 'px'
					dot.style.top  = dotY + 'px'
	
		
					// Add click event listener - Open
					dot.addEventListener( 'click', function(){
						const tooltip = dot.querySelector( '[data-js="tooltip"]' )
		
						closeAllTooltips( tooltip )
	
						openTooltip(tooltip)
					} )
	
					// Add click event listener - Close
					dot.querySelector('[data-js="close"]')?.addEventListener( 'click', function(e){
						e.stopPropagation()
						const tooltip = dot.querySelector( '[data-js="tooltip"]' )
	
						closeTooltip(tooltip)
					} )
				});
			}, 400);
		}
	}

}